<template>
  <div @click="goToTopic(topic)">
    <el-badge v-if="topic.display_order" class="pin" value="📌"></el-badge>
    <div class="topic-content">
      <div class="topic-title">
        <closed-label v-if="topic.closed"></closed-label>
        {{ topic.title }}
        <price-label :price="Math.round(topic.price)"></price-label>
      </div>

      <div class="topic-excerpt">{{ topic.excerpt }}</div>
<!--      <div class="topic-footer">-->
<!--        <span>-->
<!--          <font-awesome-icon icon="eye" />-->
<!--          {{ topic.view_count }}-->
<!--          &nbsp;-->
<!--          <font-awesome-icon icon="comment" />-->
<!--          {{ topic.reply_count }}-->
<!--          &nbsp;-->
<!--          <font-awesome-icon icon="clock" />-->
<!--          {{ topic.created_at | moment("from") }}-->
<!--        </span>-->
<!--        <span class="read">-->
<!--          <a-->
<!--            :href="-->
<!--              '/topics/' +-->
<!--                topic.id +-->
<!--                (topic.slug === null ? '' : '/' + topic.slug)-->
<!--            "-->
<!--            >「阅」</a-->
<!--          >-->
<!--        </span>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import ClosedLabel from "@/components/ClosedLabel";
import PriceLabel from "@/components/PriceLabel";

export default {
  props: {
    topic: {},
    type: {
      type: String,
    },
  },
  components: { PriceLabel, ClosedLabel },
  methods: {
    goToTopic: function() {
      let url =
        "/topics/" +
        this.topic.id +
        (this.topic.slug === null ? "" : "/" + this.topic.slug) +
      (this.type === "anonymous" ? "?admin=1" : "");
      window.open(url, "_blank");
    }
  }
};
</script>
<style scoped>
@keyframes loading-content {
  0% {
    top: 6px;
    height: 51px;
  }
  50%,
  100% {
    top: 19px;
    height: 26px;
  }
}
</style>
